<template>
  <!-- <div v-if="isVisible" class="spinner">
    <div class="loader"></div>
  </div> -->
  <!-- Blobアニメーション -->
  <!-- <div v-if="isVisible" class="blob-container"> -->
  <div v-if="isVisible" :class="['blob-container', fullScreen === true ? 'full-screen' : 'chat-mode']">
    <svg :width="fullScreen ? '200px' : '80px'" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
      <!-- グラデーションの定義 -->
      <defs>
        <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color: #E4DFF2; stop-opacity: 1" />
          <stop offset="100%" style="stop-color: #B6D7F1; stop-opacity: 1" />
        </linearGradient>
        <linearGradient id="grad2" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color: #E6F5D4; stop-opacity: 1" />
          <stop offset="100%" style="stop-color: #B8ECB6; stop-opacity: 1" />
        </linearGradient>
        <linearGradient id="grad3" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style="stop-color: #FFDEDE; stop-opacity: 1" />
          <stop offset="100%" style="stop-color: #FFD9C3; stop-opacity: 1" />
        </linearGradient>
      </defs>
      <path id="blob" d="M40,60 Q60,20 100,40 Q140,20 160,60 Q180,100 140,140 Q100,180 60,140 Q20,100 40,60 Z" fill="url(#grad1)" />
    </svg>
  </div>
</template>

<script>

export default {
  name: 'Loading',
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    fullScreen: {
      type: Boolean,
      required: true
    }
  },
  async mounted () {
    // const overlayClass = computed(() => fullScreen ? 'blob-container full-screen' : 'blob-container chat-mode')
    const blob = document.getElementById('blob')
    let gradientIndex = 1
    // グラデーションの切り替え
    setInterval(() => {
      if (gradientIndex === 1) {
        blob.setAttribute('fill', 'url(#grad1)')
      } else if (gradientIndex === 2) {
        blob.setAttribute('fill', 'url(#grad2)')
      } else {
        blob.setAttribute('fill', 'url(#grad3)')
      }
      // 1 → 2 → 3 → 1 の順に切り替え
      gradientIndex = (gradientIndex % 3) + 1
    }, 2000)
    // 2秒ごとに切り替え

    // const gradients = ['url(#grad1)', 'url(#grad2)', 'url(#grad3)']
    // const currentGradient = ref(gradients[0])
    // let gradientIndex = 1
    // let intervalId

    // intervalId = setInterval(() => {
    //   currentGradient.value = gradients[gradientIndex]
    //   gradientIndex = (gradientIndex + 1) % gradients.length
    // }, 2000)

    // this.isLoading = false
  },
  destroyed () {
    // clearInterval(intervalId)
  }
}
</script>

<style scoped>

/* Blobアニメーションコンテナ */
.blob-container {
  /* display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5; */

  /* position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000; */

  display: flex;
  align-items: center;
  justify-content: center;
}

.blob-container.full-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background-color: #F9F9F9;
}

.blob-container.chat-mode {
  /* position: absolute; */
  /* width: calc(100% - 20px); */
  /* height: 100%; */
  /* border-radius: 8px; */
  /* bottom: 0; */

  /* position: fixed;
  top: 340px;
  left: 0;
  width: 480px;
  height: 90%;
  z-index: 9999; */
  /* background-color: white; */

  /* position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999; */
}

svg {
  /* width: 200px;
  height: 200px; */
  /* width: 80px;
  height: 80px; */
}

/* 形のアニメーション */
#blob {
  animation: blobAnimation 6s infinite;
}

/* 形のアニメーション (6つの形に変更) */
@keyframes blobAnimation {
  0% {
    d: path("M40,60 Q60,20 100,40 Q140,20 160,60 Q180,100 140,140 Q100,180 60,140 Q20,100 40,60 Z");
  }
  16.6% {
    d: path("M50,50 Q70,30 110,50 Q150,30 170,70 Q190,110 130,150 Q90,190 50,130 Q10,90 50,50 Z");
  }
  33.3% {
    d: path("M30,70 Q70,20 120,30 Q160,40 150,80 Q140,130 90,150 Q50,160 30,110 Q10,90 30,70 Z");
  }
  50% {
    d: path("M70,50 Q90,10 130,30 Q170,40 150,80 Q140,120 110,160 Q70,180 40,140 Q20,100 70,50 Z");
  }
  66.6% {
    d: path("M60,60 Q80,20 120,30 Q160,40 170,80 Q180,120 120,150 Q80,180 60,140 Q40,100 60,60 Z");
  }
  83.3% {
    d: path("M80,40 Q100,20 140,30 Q160,60 150,100 Q140,140 100,160 Q60,140 40,100 Q20,80 80,40 Z");
  }
  100% {
    d: path("M40,60 Q60,20 100,40 Q140,20 160,60 Q180,100 140,140 Q100,180 60,140 Q20,100 40,60 Z");
  }
}

.spinner {
  /* display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100px;
  margin: 20px; */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  /* position: absolute;
  top: 50%;
  left: 50%; */
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>
